import cn from 'classnames';

import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { Icon } from 'ui/atoms/Icon/Icon';

import styles from './DownloadExtensionBlock.module.scss';

const link = 'https://chrome.google.com/webstore/detail/globaldatabase-b2b-emails/bjahjijchjnokbgbahdmfcjoblkicank';
const data = [
  'Instantly verify any company or website, including LinkedIn',
  'Check registration & VAT number, tax ID, address',
  'Uncover shareholders, UBOs and group structure',
  'Access up to 20 years of full financial statements',
  'Reveal verified business emails and phone numbers',
];

export const DownloadExtensionBlock = ({ className = '' }) => {
  const { t } = useInt();

  return (
    <div className={cn(styles['extension-block-wrapper'], className)}>
      <h3>{t('Get ready for your demo - Install our browser extension')}</h3>

      <div className={styles['extension-block-inner']}>
        <ul className={styles['extension-block-list']}>
          {data.map((item, idx) => (
            <li key={idx}>
              <span>
                <Icon type="check-8" />
              </span>

              {item}
            </li>
          ))}
        </ul>

        <a href={link}>
          <Button type="invert" size="xl">
            Install Extension
          </Button>
        </a>
      </div>
    </div>
  );
};
